// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Design System Variables — default theme "Aesthetic Classic" (indigo glass).
   This :root block is the default theme. Alternate themes (Celestial Tarot,
   Aurora Glass, Neon Arcade, Luxe Noir, Sakura Dawn) are applied at runtime by
   ThemeProvider (context/ThemeContext.js), which overrides these custom
   properties on <html> and sets data-theme. Density is controlled the same way
   via data-density (see styles/density.css). Keeping everything token-driven is
   what lets the whole app re-skin from one place. See docs/frontend/DESIGN_REDESIGN.md. */
:root {
  /* Colors - Primary Palette */
  --color-primary: #667eea;
  --color-primary-dark: #5568d3;
  --color-primary-light: #7e8ff0;
  --color-secondary: #764ba2;
  --color-accent: #ff6b9d;
  --color-accent-light: #ff8cb3;

  /* Semantic Colors */
  --color-success: #4CAF50;
  --color-success-light: #66BB6A;
  --color-error: #ef4444;
  --color-error-light: #f87171;
  --color-warning: #ff9800;
  --color-warning-light: #ffa726;
  --color-info: #2196f3;
  --color-info-light: #42a5f5;

  /* Neutral Colors */
  --color-dark: #0f0f1e;
  --color-dark-lighter: #1a1a2e;
  --color-dark-light: #2a2a3e;
  --color-gray: #4a4a5e;
  --color-gray-light: #6a6a7e;
  --color-light: #f7f7ff;
  --color-white: #ffffff;

  /* Background Gradients */
  --gradient-primary: linear-gradient(135deg, var(--color-primary) 0%, var(--color-secondary) 100%);
  --gradient-bg: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  --gradient-dark: linear-gradient(135deg, #1a1a2e 0%, #2a2a3e 100%);
  --gradient-accent: linear-gradient(135deg, var(--color-accent) 0%, var(--color-secondary) 100%);

  /* Glassmorphism */
  --glass-bg: rgba(255, 255, 255, 0.1);
  --glass-bg-strong: rgba(255, 255, 255, 0.15);
  --glass-border: rgba(255, 255, 255, 0.2);
  --glass-border-strong: rgba(255, 255, 255, 0.3);

  /* Semantic text colours — flip with light/dark mode (see constants/themes.js).
     Default (dark) values match the whites pages used before, so dark mode is
     unchanged; light mode overrides these to dark ink. */
  --text-primary: rgba(255, 255, 255, 0.95);
  --text-muted: rgba(255, 255, 255, 0.7);
  --text-faint: rgba(255, 255, 255, 0.5);

  /* Spacing Scale */
  --space-xs: 0.25rem;    /* 4px */
  --space-sm: 0.5rem;     /* 8px */
  --space-md: 1rem;       /* 16px */
  --space-lg: 1.5rem;     /* 24px */
  --space-xl: 2rem;       /* 32px */
  --space-2xl: 3rem;      /* 48px */
  --space-3xl: 4rem;      /* 64px */

  /* Border Radius */
  --radius-sm: 0.25rem;   /* 4px */
  --radius-md: 0.5rem;    /* 8px */
  --radius-lg: 0.75rem;   /* 12px */
  --radius-xl: 1rem;      /* 16px */
  --radius-full: 9999px;

  /* Shadows */
  --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.1);
  --shadow-md: 0 4px 6px rgba(0, 0, 0, 0.15);
  --shadow-lg: 0 10px 15px rgba(0, 0, 0, 0.2);
  --shadow-xl: 0 20px 25px rgba(0, 0, 0, 0.25);
  --shadow-glow: 0 0 20px rgba(102, 126, 234, 0.4);

  /* Typography */
  --font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  /* Display/heading font. Default = same as body; themes may override (e.g. Cinzel). */
  --font-display: var(--font-family);

  --font-size-xs: 0.75rem;    /* 12px */
  --font-size-sm: 0.875rem;   /* 14px */
  --font-size-base: 1rem;     /* 16px */
  --font-size-lg: 1.125rem;   /* 18px */
  --font-size-xl: 1.25rem;    /* 20px */
  --font-size-2xl: 1.5rem;    /* 24px */
  --font-size-3xl: 1.875rem;  /* 30px */
  --font-size-4xl: 2.25rem;   /* 36px */

  --font-weight-normal: 400;
  --font-weight-medium: 500;
  --font-weight-semibold: 600;
  --font-weight-bold: 700;

  --line-height-tight: 1.25;
  --line-height-normal: 1.5;
  --line-height-relaxed: 1.75;

  /* Transitions */
  --transition-fast: 150ms cubic-bezier(0.4, 0, 0.2, 1);
  --transition-base: 200ms cubic-bezier(0.4, 0, 0.2, 1);
  --transition-slow: 300ms cubic-bezier(0.4, 0, 0.2, 1);

  /* Chrome density tokens — overridden by [data-density] (styles/density.css).
     Default ("comfortable") preserves the original spacious layout. */
  --nav-pad: var(--space-md);
  --nav-gap: var(--space-sm);
  --nav-item-pad-y: var(--space-md);
  --nav-item-pad-x: var(--space-lg);
  --nav-item-radius: var(--radius-lg);
  --nav-item-font: var(--font-size-base);
  --nav-mb: var(--space-xl);
  --header-pad-y: var(--space-lg);
  --header-mb: var(--space-xl);
  --header-logo-size: var(--font-size-4xl);
  --header-subtitle-size: var(--font-size-lg);
  --page-tabs-pad: 10px;
  --page-tab-pad-y: 12px;
  --page-tab-pad-x: 24px;
  --page-title-size: 2rem;
  --page-title-mb: 20px;

  /* Z-index Scale */
  --z-dropdown: 1000;
  --z-sticky: 1020;
  --z-fixed: 1030;
  --z-modal-backdrop: 1040;
  --z-modal: 1050;
  --z-popover: 1060;
  --z-tooltip: 1070;
  --z-command: 1080;

  /* Breakpoints (for reference in JS) */
  --breakpoint-sm: 640px;
  --breakpoint-md: 768px;
  --breakpoint-lg: 1024px;
  --breakpoint-xl: 1280px;
}

/* Dark theme adjustments (default) */
body {
  background: var(--gradient-bg);
  color: var(--color-white);
}

/* Display font for headings (default = body font, themes may override). */
h1,
h2,
h3 {
  font-family: var(--font-display);
}

/* Respect users who prefer reduced motion (accessibility, DESIGN_REDESIGN §6.6). */
@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.001ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.001ms !important;
    scroll-behavior: auto !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/variables.css"],"names":[],"mappings":"AAAA;;;;;;0FAM0F;AAC1F;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,6BAA6B;EAC7B,8BAA8B;EAC9B,0BAA0B;EAC1B,uBAAuB;EACvB,6BAA6B;;EAE7B,oBAAoB;EACpB,wBAAwB;EACxB,8BAA8B;EAC9B,sBAAsB;EACtB,4BAA4B;EAC5B,wBAAwB;EACxB,8BAA8B;EAC9B,qBAAqB;EACrB,2BAA2B;;EAE3B,mBAAmB;EACnB,qBAAqB;EACrB,6BAA6B;EAC7B,2BAA2B;EAC3B,qBAAqB;EACrB,2BAA2B;EAC3B,sBAAsB;EACtB,sBAAsB;;EAEtB,yBAAyB;EACzB,iGAAiG;EACjG,gEAAgE;EAChE,kEAAkE;EAClE,+FAA+F;;EAE/F,kBAAkB;EAClB,oCAAoC;EACpC,4CAA4C;EAC5C,wCAAwC;EACxC,+CAA+C;;EAE/C;;yDAEuD;EACvD,yCAAyC;EACzC,sCAAsC;EACtC,sCAAsC;;EAEtC,kBAAkB;EAClB,mBAAmB,KAAK,QAAQ;EAChC,kBAAkB,MAAM,QAAQ;EAChC,gBAAgB,QAAQ,SAAS;EACjC,kBAAkB,MAAM,SAAS;EACjC,gBAAgB,QAAQ,SAAS;EACjC,iBAAiB,OAAO,SAAS;EACjC,iBAAiB,OAAO,SAAS;;EAEjC,kBAAkB;EAClB,oBAAoB,IAAI,QAAQ;EAChC,mBAAmB,KAAK,QAAQ;EAChC,oBAAoB,IAAI,SAAS;EACjC,iBAAiB,OAAO,SAAS;EACjC,qBAAqB;;EAErB,YAAY;EACZ,yCAAyC;EACzC,0CAA0C;EAC1C,2CAA2C;EAC3C,4CAA4C;EAC5C,gDAAgD;;EAEhD,eAAe;EACf;kFACgF;EAChF,qFAAqF;EACrF,kCAAkC;;EAElC,uBAAuB,KAAK,SAAS;EACrC,wBAAwB,IAAI,SAAS;EACrC,sBAAsB,MAAM,SAAS;EACrC,wBAAwB,IAAI,SAAS;EACrC,uBAAuB,KAAK,SAAS;EACrC,uBAAuB,KAAK,SAAS;EACrC,yBAAyB,GAAG,SAAS;EACrC,wBAAwB,IAAI,SAAS;;EAErC,yBAAyB;EACzB,yBAAyB;EACzB,2BAA2B;EAC3B,uBAAuB;;EAEvB,yBAAyB;EACzB,yBAAyB;EACzB,2BAA2B;;EAE3B,gBAAgB;EAChB,qDAAqD;EACrD,qDAAqD;EACrD,qDAAqD;;EAErD;sEACoE;EACpE,0BAA0B;EAC1B,0BAA0B;EAC1B,iCAAiC;EACjC,iCAAiC;EACjC,mCAAmC;EACnC,sCAAsC;EACtC,yBAAyB;EACzB,+BAA+B;EAC/B,4BAA4B;EAC5B,wCAAwC;EACxC,2CAA2C;EAC3C,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;;EAErB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,wBAAwB;EACxB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;;EAEjB,sCAAsC;EACtC,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA,qCAAqC;AACrC;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA,0EAA0E;AAC1E;;;EAGE,gCAAgC;AAClC;;AAEA,mFAAmF;AACnF;EACE;;;IAGE,sCAAsC;IACtC,uCAAuC;IACvC,uCAAuC;IACvC,gCAAgC;EAClC;AACF","sourcesContent":["/* Design System Variables — default theme \"Aesthetic Classic\" (indigo glass).\n   This :root block is the default theme. Alternate themes (Celestial Tarot,\n   Aurora Glass, Neon Arcade, Luxe Noir, Sakura Dawn) are applied at runtime by\n   ThemeProvider (context/ThemeContext.js), which overrides these custom\n   properties on <html> and sets data-theme. Density is controlled the same way\n   via data-density (see styles/density.css). Keeping everything token-driven is\n   what lets the whole app re-skin from one place. See docs/frontend/DESIGN_REDESIGN.md. */\n:root {\n  /* Colors - Primary Palette */\n  --color-primary: #667eea;\n  --color-primary-dark: #5568d3;\n  --color-primary-light: #7e8ff0;\n  --color-secondary: #764ba2;\n  --color-accent: #ff6b9d;\n  --color-accent-light: #ff8cb3;\n\n  /* Semantic Colors */\n  --color-success: #4CAF50;\n  --color-success-light: #66BB6A;\n  --color-error: #ef4444;\n  --color-error-light: #f87171;\n  --color-warning: #ff9800;\n  --color-warning-light: #ffa726;\n  --color-info: #2196f3;\n  --color-info-light: #42a5f5;\n\n  /* Neutral Colors */\n  --color-dark: #0f0f1e;\n  --color-dark-lighter: #1a1a2e;\n  --color-dark-light: #2a2a3e;\n  --color-gray: #4a4a5e;\n  --color-gray-light: #6a6a7e;\n  --color-light: #f7f7ff;\n  --color-white: #ffffff;\n\n  /* Background Gradients */\n  --gradient-primary: linear-gradient(135deg, var(--color-primary) 0%, var(--color-secondary) 100%);\n  --gradient-bg: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  --gradient-dark: linear-gradient(135deg, #1a1a2e 0%, #2a2a3e 100%);\n  --gradient-accent: linear-gradient(135deg, var(--color-accent) 0%, var(--color-secondary) 100%);\n\n  /* Glassmorphism */\n  --glass-bg: rgba(255, 255, 255, 0.1);\n  --glass-bg-strong: rgba(255, 255, 255, 0.15);\n  --glass-border: rgba(255, 255, 255, 0.2);\n  --glass-border-strong: rgba(255, 255, 255, 0.3);\n\n  /* Semantic text colours — flip with light/dark mode (see constants/themes.js).\n     Default (dark) values match the whites pages used before, so dark mode is\n     unchanged; light mode overrides these to dark ink. */\n  --text-primary: rgba(255, 255, 255, 0.95);\n  --text-muted: rgba(255, 255, 255, 0.7);\n  --text-faint: rgba(255, 255, 255, 0.5);\n\n  /* Spacing Scale */\n  --space-xs: 0.25rem;    /* 4px */\n  --space-sm: 0.5rem;     /* 8px */\n  --space-md: 1rem;       /* 16px */\n  --space-lg: 1.5rem;     /* 24px */\n  --space-xl: 2rem;       /* 32px */\n  --space-2xl: 3rem;      /* 48px */\n  --space-3xl: 4rem;      /* 64px */\n\n  /* Border Radius */\n  --radius-sm: 0.25rem;   /* 4px */\n  --radius-md: 0.5rem;    /* 8px */\n  --radius-lg: 0.75rem;   /* 12px */\n  --radius-xl: 1rem;      /* 16px */\n  --radius-full: 9999px;\n\n  /* Shadows */\n  --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.1);\n  --shadow-md: 0 4px 6px rgba(0, 0, 0, 0.15);\n  --shadow-lg: 0 10px 15px rgba(0, 0, 0, 0.2);\n  --shadow-xl: 0 20px 25px rgba(0, 0, 0, 0.25);\n  --shadow-glow: 0 0 20px rgba(102, 126, 234, 0.4);\n\n  /* Typography */\n  --font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  /* Display/heading font. Default = same as body; themes may override (e.g. Cinzel). */\n  --font-display: var(--font-family);\n\n  --font-size-xs: 0.75rem;    /* 12px */\n  --font-size-sm: 0.875rem;   /* 14px */\n  --font-size-base: 1rem;     /* 16px */\n  --font-size-lg: 1.125rem;   /* 18px */\n  --font-size-xl: 1.25rem;    /* 20px */\n  --font-size-2xl: 1.5rem;    /* 24px */\n  --font-size-3xl: 1.875rem;  /* 30px */\n  --font-size-4xl: 2.25rem;   /* 36px */\n\n  --font-weight-normal: 400;\n  --font-weight-medium: 500;\n  --font-weight-semibold: 600;\n  --font-weight-bold: 700;\n\n  --line-height-tight: 1.25;\n  --line-height-normal: 1.5;\n  --line-height-relaxed: 1.75;\n\n  /* Transitions */\n  --transition-fast: 150ms cubic-bezier(0.4, 0, 0.2, 1);\n  --transition-base: 200ms cubic-bezier(0.4, 0, 0.2, 1);\n  --transition-slow: 300ms cubic-bezier(0.4, 0, 0.2, 1);\n\n  /* Chrome density tokens — overridden by [data-density] (styles/density.css).\n     Default (\"comfortable\") preserves the original spacious layout. */\n  --nav-pad: var(--space-md);\n  --nav-gap: var(--space-sm);\n  --nav-item-pad-y: var(--space-md);\n  --nav-item-pad-x: var(--space-lg);\n  --nav-item-radius: var(--radius-lg);\n  --nav-item-font: var(--font-size-base);\n  --nav-mb: var(--space-xl);\n  --header-pad-y: var(--space-lg);\n  --header-mb: var(--space-xl);\n  --header-logo-size: var(--font-size-4xl);\n  --header-subtitle-size: var(--font-size-lg);\n  --page-tabs-pad: 10px;\n  --page-tab-pad-y: 12px;\n  --page-tab-pad-x: 24px;\n  --page-title-size: 2rem;\n  --page-title-mb: 20px;\n\n  /* Z-index Scale */\n  --z-dropdown: 1000;\n  --z-sticky: 1020;\n  --z-fixed: 1030;\n  --z-modal-backdrop: 1040;\n  --z-modal: 1050;\n  --z-popover: 1060;\n  --z-tooltip: 1070;\n  --z-command: 1080;\n\n  /* Breakpoints (for reference in JS) */\n  --breakpoint-sm: 640px;\n  --breakpoint-md: 768px;\n  --breakpoint-lg: 1024px;\n  --breakpoint-xl: 1280px;\n}\n\n/* Dark theme adjustments (default) */\nbody {\n  background: var(--gradient-bg);\n  color: var(--color-white);\n}\n\n/* Display font for headings (default = body font, themes may override). */\nh1,\nh2,\nh3 {\n  font-family: var(--font-display);\n}\n\n/* Respect users who prefer reduced motion (accessibility, DESIGN_REDESIGN §6.6). */\n@media (prefers-reduced-motion: reduce) {\n  *,\n  *::before,\n  *::after {\n    animation-duration: 0.001ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.001ms !important;\n    scroll-behavior: auto !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
